import { Heading, HeadingProps } from "@chakra-ui/react"

export default function Header(props: HeadingProps) {
  return (
    <Heading as={"h3"} my={{ base: 10 }} {...props}>
      {props.children}
    </Heading>
  )
}
